<template>
  <core-form col="1" label-align="left" label-width :editable="true" label-direction="vertical" style="height: 100%; overflow: auto;">
    <!-- 自定义UI选择 -->
    <core-form-item label="" v-if="isUiStyle && uistyle.length > 1">
      <!-- pc -->
      <!-- phone -->
      <div class="test__body" >
        <Row :gutter="16">
          <template v-for="(item, index) in uistyle" >
          <i-col style="padding: 8px;"  :key="index" v-if="item.key" :xs="12" :sm="12" :md="12" :lg="12">
            <Card :bordered="false" >
              <p slot="title" :class="{'fx-color-brand':$store.state.core.uiKey==item.key}">{{ item.title }}</p>
              <!-- <a href="#" slot="extra" @click.prevent="changeLimit2(item)">应用</a> -->
              <div style="max-height:230px;overflow:hidden">
              <img :src="item.imgurl" @click="changeLimit2(item)" style="max-width: 100%;height: auto!important; cursor: pointer;" />
              </div>
            </Card>
          </i-col>
          </template>
        </Row>
      </div>
    </core-form-item>
  </core-form>
</template>
<script>
export default {
  data() {
    return {
      uistyle:[]
      // themas
      // thema: "",
      // themaColor: "",
    };
  },
  components: {
    // modifyFace,
    // pc2,
    // top
  },
  mounted() {
    let _this = this 
    _this.getUistyle()
  },
  computed: {
    isshowchangethema() {
      return this.$app.helper.screen.isPC && this.$app.ProjSetting.disablethema != true;
    },
    isUiStyle() {
      return this.$store.state.core.isUiStyle;
    },
    // uistyle() {
    //   //分为

    //   return this.$store.state.core.uistyle;
    // },
    // curthema: {
    //   get() {
    //     return this.$store.state.core.thema;
    //   },
    //   set(val) {
    //     this.$curl.post("/api/core/personal/saveThema", { thema: val }).then((res) => {
    //       this.$store.commit("corgete/setThema", val);
    //     });
    //   },
    // },
  },
  methods: {
    // getsrc(layout, thema) {
    //   return require(`./images/${layout.name}-layout-${thema}.png`);
    // },
     getUistyle(){
      let _this = this 
      let  device = _this.$app.helper.screen.isPC  ? "pc" : "phone";
      _this.$curl.get("/api/core/personal/getUistyle", {  device  })
      .then((res) => {
          // this.$store.commit("corgete/setThema", val);
          _this.uistyle = res.uistyle
        });
    },
    // changeLimit(layout, thema) {
    //   let _this = this;
    //   _this.$curl
    //     .post("/api/core/personal/saveThema", {
    //       layout: layout.name,
    //       thema,
    //       img: _this.$store.state.core.sideBarimg,
    //       topimg: _this.$store.state.core.topimg,
    //     })
    //     .then((res) => {
    //       window.location.reload();
    //     });
    // },
    changeLimit2(userUistyle) {
      let _this = this;
      console.log(userUistyle);
      _this.$curl
        .post("/api/core/personal/saveThema2", {
          layout: userUistyle.layout,
          thema: userUistyle.thema,
          device: _this.$app.helper.screen.isPC ? "pc" : "phone",
          title: userUistyle.title,
          menu: userUistyle.menu,
          img: _this.$store.state.core.sideBarimg,
          topimg: _this.$store.state.core.topimg,
          key:userUistyle.key
        })
        .then((res) => {
          window.location.reload();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.test {
  .test-img {
    transition: all 0.3s;
    transform: scale(1);
  }
  &:hover .test-img {
    transform: scale(1.2);
  }
}
</style>
